import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { LiquidationAttributes } from '../../interfaces/liquidation.interface';

/**
 * Liquidation Price List Cell Renderer
 *
 * Displays price list information:
 * - Code (bold, small font)
 * - Name (below)
 */
@Component({
  selector: 'app-liquidation-pricelist-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="truncate">
      <span class="block truncate font-bold text-[10px]">{{ code }}</span>
      <span class="block truncate text-xs">{{ name }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiquidationPriceListCellRendererComponent implements CellRenderer<LiquidationAttributes> {
  @Input() params!: CellRendererParams<LiquidationAttributes>;

  get code(): string {
    return this.params?.data?.priceList?.code || '-';
  }

  get name(): string {
    return this.params?.data?.priceList?.name || '';
  }
}
